import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, X, ChatCircleDots } from "@phosphor-icons/react";

export default function FloatingHotline() {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-6 right-6 z-40" data-testid="floating-hotline">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.9 }}
            transition={{ duration: 0.25 }}
            className="mb-4 w-80 bg-[#0A0A0A] border border-white/10 shadow-2xl shadow-black/50"
          >
            <div className="bg-[#FFD300] px-5 py-4 flex items-center justify-between">
              <div>
                <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-black/80">24/7 OPERATIONS</div>
                <div className="font-heading text-lg tracking-tight">Need immediate response?</div>
              </div>
              <button onClick={() => setOpen(false)} data-testid="hotline-close"><X size={20} /></button>
            </div>
            <div className="p-5 space-y-4">
              <a href="tel:+14106450722" data-testid="hotline-call" className="flex items-center gap-3 p-4 bg-[#141414] hover:bg-[#1C1C1C] transition-colors group">
                <Phone size={24} weight="duotone" className="text-[#FFD300]" />
                <div>
                  <div className="font-mono text-[10px] tracking-[0.2em] text-neutral-400">EMERGENCY DISPATCH</div>
                  <div className="font-heading text-xl">410-645-0722</div>
                </div>
              </a>
              <a href="/booking" data-testid="hotline-book" className="block p-4 bg-[#141414] hover:bg-[#1C1C1C] transition-colors">
                <div className="font-mono text-[10px] tracking-[0.2em] text-neutral-400">NON-EMERGENCY</div>
                <div className="font-heading text-base mt-1">Request a quote →</div>
              </a>
              <div className="font-mono text-[10px] text-neutral-500 leading-relaxed">
                Avg. response time: <span className="text-[#039855]">8 minutes</span> · Confidential intake
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <motion.button
        onClick={() => setOpen(!open)}
        data-testid="hotline-toggle"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="w-14 h-14 bg-[#FFD300] hover:bg-[#FFE149] text-white rounded-full flex items-center justify-center shadow-2xl shadow-[#FFD300]/30 relative"
      >
        <div className="absolute inset-0 bg-[#FFD300] rounded-full animate-ping opacity-30" />
        {open ? <X size={22} /> : <ChatCircleDots size={22} weight="duotone" />}
      </motion.button>
    </div>
  );
}
